import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormField from './FormField';

/**
 * Multi-select day-of-week toggles (batch session days).
 */
export default function DayToggleGroup({
    label,
    days,
    selected = new Set(),
    onToggle,
    required = false,
    note,
    className = '',
    disabled = false,
}) {
    const { t } = useTranslation();

    const dayOptions = useMemo(() => {
        if (days) return days;
        return [1, 2, 3, 4, 5, 6, 7].map((v) => ({
            v,
            n: t(`days.short.${v}`),
        }));
    }, [days, t]);

    return (
        <FormField
            label={label ?? t('form.sessionDays')}
            required={required}
            note={note ?? t('form.selectOneDay')}
            className={className}
        >
            <div className={`flex flex-wrap gap-2 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
                {dayOptions.map((d) => {
                    const active = selected.has(d.v);
                    return (
                        <button
                            type="button"
                            key={d.v}
                            onClick={() => !disabled && onToggle(d.v)}
                            disabled={disabled}
                            className={`px-3 py-1 rounded-lg border text-sm font-medium transition-colors ${
                                active
                                    ? 'bg-purple-600 text-white border-purple-600'
                                    : 'bg-white text-gray-700 border-gray-300 hover:border-purple-400'
                            }`}
                        >
                            {d.n}
                        </button>
                    );
                })}
            </div>
        </FormField>
    );
}
